// Layout
const dashboardLayout = () => import('@/layouts/CompanyLayout/DashboardLayout/dashboardLayout.vue')

const trips = () => import('./views/index')
const showTrip = () => import('./views/showTrip')

// start Routes
export default [
  {
    path: '/company/trips',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'companyTrips',
      meta: {
        name: 'companyTrips',
        parentName: 'trips',
        userType: '',
        permission: '',
        role: 'transportation.company_owner'
      },
      component: trips
    },
    {
      path: 'show-trip/:id',
      name: 'companyShowTrip',
      props: true,
      meta: {
        name: 'companyShowTrip',
        parentName: 'trips',
        userType: '',
        permission: '',
        role: 'transportation.company_owner'
      },
      component: showTrip
    }
    ]
  }
]
